export const REACT_URL = 'https://reactjs.org';
export const VITE_URL = 'https://vitejs.dev/guide/features.html';

export const ACTIVE_ACCOUNT_STATUS = 'Active';
export const INACTIVE_ACCOUNT_STATUS = '—';

export const DEFAULT_MODULE = 'dashboard';
